import { Lock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { isNativePlatform } from '@/utils/platform';

interface Props {
  moduleName: string;
}

function ModuleAccessDenied({ moduleName }: Props) {
  const { t } = useTranslation('common', { keyPrefix: 'ModuleAccessDenied' });
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4 text-center">
      <div className="bg-neutral-100 p-5 rounded-full mb-6">
        <Lock className="h-10 w-10 text-neutral-400" />
      </div>
      <h2 className="text-xl font-semibold text-neutral-900 mb-2">{t('title')}</h2>
      <p className="text-neutral-600 max-w-sm mb-1">
        <Trans t={t} i18nKey="body" values={{ module: moduleName }} components={{ b: <span className="font-medium" /> }} />
      </p>
      {/* Native: no path towards billing, not even a link to a price-free page —
          App Store 3.1.1 / 3.1.3(c). Web keeps the link. */}
      {isNativePlatform() ? (
        <p className="text-sm text-neutral-500 mt-3">
          {t('askAdmin')}
        </p>
      ) : (
        <p className="text-sm text-neutral-500 mt-3">
          <Trans
            t={t}
            i18nKey="askAdminWeb"
            components={{ link: <Link to="/subscriptions" className="text-primary-600 hover:underline" /> }}
          />
        </p>
      )}
    </div>
  );
}

export default ModuleAccessDenied;
